import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FiArrowUpRight, FiBookOpen } from "react-icons/fi";

function Publications() {
  const [publications, setPublications] = useState([]);

  useEffect(() => {
    fetch("/data/publicationsData.json")
      .then(response => response.json())
      .then(setPublications)
      .catch(() => setPublications([]));
  }, []);

  return (
    <section id="publications" className="section-shell">
      <div className="section-heading">
        <p className="section-title">Publications</p>
        <span className="section-icon" aria-hidden="true"><FiBookOpen /></span>
      </div>

      {publications.length === 0 ? (
        <p className="text-sm text-white">No publications yet.</p>
      ) : (
        <div className="publication-bento">
          {publications.map((publication, index) => (
            <motion.a
              key={publication.title || index}
              href={publication.url}
              target="_blank"
              rel="noopener noreferrer"
              className="publication-bento-card group"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.45, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className="publication-bento-content">
                <h3 className="publication-bento-title">{publication.title}</h3>

                {publication.abstract && (
                  <p className="publication-bento-abstract">{publication.abstract}</p>
                )}

                {publication.authors?.length > 0 && (
                  <p className="publication-bento-authors">{publication.authors.join(", ")}</p>
                )}

                <div className="publication-bento-action">
                  <span>Read paper</span>
                  <FiArrowUpRight aria-hidden="true" />
                </div>
              </div>

              <div className="publication-bento-meta">
                {publication.journal && (
                  <p className="publication-bento-journal">{publication.journal}</p>
                )}

                <div className="publication-bento-facts">
                  {publication.type && <span>{publication.type}</span>}
                  {publication.year && <span>{publication.year}</span>}
                </div>

                {publication.doi && (
                  <p className="publication-bento-doi">DOI: {publication.doi}</p>
                )}

                {publication.keywords?.length > 0 && (
                  <div className="publication-bento-keywords">
                    {publication.keywords.slice(0, 3).map(keyword => (
                      <span key={keyword}>{keyword}</span>
                    ))}
                  </div>
                )}
              </div>
            </motion.a>
          ))}
        </div>
      )}
    </section>
  );
}

export default Publications;
